import { BillingDetails } from '@/models/billing/BillingDetails';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Component({
  selector: 'app-shop-bill-list-table',
  templateUrl: './shop-bill-list-table.component.html',
  styleUrl: './shop-bill-list-table.component.scss'
})
export class ShopBillListTableComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
  shopBillDetails: BillingDetails[] = [];
  getAllShopBillDetails: BillingDetails[] = [];
  searchText: any;
  productNameDetails: string[] = [];
  productCodeDetails: string[] = [];
  billDateDetails: string[] = [];
  billTypeDetails: string[] = [];
  productName: string = '';
  productCode: string = '';
  billDate: string = '';
  billTypes: string = '';
  private secretKey = "#EVOL-&$%$DF%SION*^%#^*F&%^DFSEYUJ";

  constructor(private appService: AppService, private toastr: ToastrService, private spinner: NgxSpinnerService,
    private datePipe: DatePipe, private router: Router) { }

  ngOnInit(): void {
    this.getAllBillDetails();
  }

  // get product details
  getAllBillDetails() {
    this.spinner.show();
    this.appService.getAllBillDetails()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.spinner.hide();
        this.getAllShopBillDetails = data.sort((a, b) => b.billId - a.billId);
        // get unique details for dropdowns  - productName, productCode, productCreationDate, productStatus
        this.productNameDetails = [...new Set(this.getAllShopBillDetails.flatMap(item => item.products.map(product => product.productName)))];
        this.productCodeDetails = [...new Set(this.getAllShopBillDetails.flatMap(item => item.products.map(product => product.productCode)))];
        this.billDateDetails = [...new Set(this.getAllShopBillDetails.map(item =>
          item.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB') : '-'))];
        this.billTypeDetails = [...new Set(this.getAllShopBillDetails.map(item => item.billType))];
        this.shopBillDetails = this.getAllShopBillDetails
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something went wrong, please try again...")
      });
  }

  getFormattedAmount(amount: number): string {
    return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 2 }).format(amount);
  }

  printBill(billId: number, billTypes: string) {
    const encryptedBillId = CryptoJS.AES.encrypt(String(billId), this.secretKey).toString();
    const encryptedBillType = CryptoJS.AES.encrypt(String(billTypes), this.secretKey).toString();
    this.router.navigate(['/bill'], { queryParams: { billId: encryptedBillId, billType: encryptedBillType } });
  }


  // Current select filter value set function
  updateDetails(event: any, filterType: string) {

    // const value = event.target.value;

    // switch (filterType) {
    //   case 'name':
    //     this.productName = value !== 'Select Product Name' ? value : 'all';
    //     break;
    //   case 'commodity':
    //     this.productCode = value !== 'Select Product code' ? value : 'all';
    //     break;
    //   case 'date':
    //     this.billDate = value !== 'Select Bill Date' ? value : 'all';
    //     break;
    //   case 'date':
    //     this.billTypes = value !== 'Select Bill Type' ? value : 'all';
    //     break;

    //   default:
    //     break;
    // }

    // this.applyFilter();
  }

  // Apply filter function
  applyFilter() {
    let filteredData = [...this.getAllShopBillDetails];

    // Apply product name filter
    if (this.productName && this.productName !== 'all') {
      filteredData = filteredData.filter(item =>
        item.products.some(product => product.productName === this.productName)
      );
    }

    // Update available options for product code, bill date, and bill type based on product name filter
    this.productCodeDetails = [...new Set(filteredData.flatMap(item => item.products.map(product => product.productCode)))];
    this.billDateDetails = [...new Set(filteredData.map(item =>
      this.datePipe.transform(item.createdAt, 'dd/MM/yyyy')
    ))];
    this.billTypeDetails = [...new Set(filteredData.map(item => item.billType))];

    // Apply product code filter
    if (this.productCode && this.productCode !== 'all') {
      filteredData = filteredData.filter(item =>
        item.products.some(product => product.productCode === this.productCode)
      );
    }

    // Update available options for bill date and bill type based on product code filter
    this.billDateDetails = [...new Set(filteredData.map(item =>
      this.datePipe.transform(item.createdAt, 'dd/MM/yyyy')
    ))];
    this.billTypeDetails = [...new Set(filteredData.map(item => item.billType))];

    // Apply bill date filter
    if (this.billDate && this.billDate !== 'all') {
      filteredData = filteredData.filter(item =>
        this.datePipe.transform(item.createdAt, 'dd/MM/yyyy') === this.billDate
      );
    }

    // Apply bill type filter
    if (this.billTypes && this.billTypes !== 'all') {
      filteredData = filteredData.filter(item => item.billType === this.billTypes);
    }

    // Set filtered data to be displayed
    this.shopBillDetails = filteredData;
  }




  // Remove filter function values
  resetReviewFilter() {
    this.searchText = '';
    this.productName = '';
    this.productCode = '';
    this.billDate = '';
    this.billTypes = '';

    this.shopBillDetails = [...this.getAllShopBillDetails];
    this.productNameDetails = [...new Set(this.getAllShopBillDetails.flatMap(item => item.products.map(product => product.productName)))];
    this.productCodeDetails = [...new Set(this.getAllShopBillDetails.flatMap(item => item.products.map(product => product.productCode)))];
    this.billDateDetails = [...new Set(this.getAllShopBillDetails.map(item =>
      item.createdAt ? new Date(item.createdAt).toLocaleDateString('en-GB') : '-'
    ))];
    this.billTypeDetails = [...new Set(this.getAllShopBillDetails.map(item => item.billType))];
  }

  onDate(): void {
    const fromDate = (document.getElementById('fromDate') as HTMLInputElement).value;
    const toDate = (document.getElementById('toDate') as HTMLInputElement).value;

    if (fromDate && toDate) {
      const fromDateOnly = new Date(fromDate).setHours(0, 0, 0, 0);
      const toDateOnly = new Date(toDate).setHours(23, 59, 59, 999);

      this.shopBillDetails = this.getAllShopBillDetails
        .filter(item => {
          const createdAtDate = new Date(item.createdAt).setHours(0, 0, 0, 0);
          return createdAtDate >= fromDateOnly && createdAtDate <= toDateOnly;
        })
        .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
    } else {
      this.shopBillDetails = this.getAllShopBillDetails;
    }
  }

  //Download excel file
  downloadExcel() {
    // this.spinner.show();
    // const worksheetData = this.shopBillDetails.map((report, index) => ({
    //   'S.No': index + 1,
    //   'Customer Name': report?.customerName || '-',
    //   'Phone Number': report?.phoneNumber || '-',
    //   'City': report?.city || '-',
    //   'Bill Type': report?.billType || '-',
    //   'Bill Amount': (report?.subTotal ? report.subTotal.toFixed(2) : '0.00'),
    //   'Discount': (report?.discount ? report.discount.toFixed(2) : '0.00'),
    //   'Paypal Amount': (report?.totalAmount ? report.totalAmount.toFixed(2) : '0.00'),
    //   'Bill Date': report?.createdAt ? new Date(report.createdAt).toLocaleDateString('en-GB') : '-',
    // }));

    // const worksheet = XLSX.utils.json_to_sheet(worksheetData);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, 'Filtered Reports');

    // const filename = `Shop bill report, ${new Date().toLocaleDateString()}.xlsx`;

    // try {
    //   XLSX.writeFile(workbook, filename);
    //   this.spinner.hide();
    //   this.toastr.success('Excel file downloaded successfully!');
    // } catch (error) {
    //   this.spinner.hide();
    //   this.toastr.error('Error during file export:', error);
    //   console.error('Error during file export:', error);
    // }
  }

  downloadPDF() {
    // this.spinner.show();
    // const doc = new jsPDF('p', 'mm', 'a4');

    // doc.setFontSize(16);
    // doc.text('Lovely Fashion - Madurai', 105, 15, { align: 'center' });

    // const headers = [
    //   ['S.No', 'Customer Name', 'Phone Number', 'City', 'Bill Type', 'Bill Amount', 'Discount', 'Paypal Amount', 'Bill Date']
    // ];

    // const data = this.shopBillDetails.map((report, index) => [
    //   index + 1,
    //   report?.customerName || '-',
    //   report?.phoneNumber || '-',
    //   report?.city || '-',
    //   report?.billType || '-',
    //   (report?.subTotal ? report.subTotal.toFixed(2) : '0.00'),
    //   (report?.discount ? report.discount.toFixed(2) : '0.00'),
    //   (report?.totalAmount ? report.totalAmount.toFixed(2) : '0.00'),
    //   report?.createdAt ? new Date(report.createdAt).toLocaleDateString('en-GB') : '-',
    // ]);

    // autoTable(doc, {
    //   head: headers,
    //   body: data,
    //   startY: 25,
    //   theme: 'grid',
    //   styles: { fontSize: 10, halign: 'center', valign: 'middle' },
    //   headStyles: { fillColor: [223, 193, 255], halign: 'center', valign: 'middle' },
    //   alternateRowStyles: { fillColor: [240, 240, 240] },
    //   columnStyles: {
    //     0: { cellWidth: 10, halign: 'center' },
    //     1: { cellWidth: 30, halign: 'center' },
    //     2: { cellWidth: 25, halign: 'center' },
    //     3: { cellWidth: 20, halign: 'center' },
    //     4: { cellWidth: 20, halign: 'center' },
    //     5: { cellWidth: 17, halign: 'center' },
    //     6: { cellWidth: 20, halign: 'center' },
    //     7: { cellWidth: 25, halign: 'center' },
    //     8: { cellWidth: 25, halign: 'center' },
    //   }
    // });

    // doc.save(`Shop_Bill_Report_${new Date().toLocaleDateString()}.pdf`);
    // this.spinner.hide();
    // this.toastr.success('PDF file downloaded successfully!');
  }



}
